
  import { create } from "zustand";
  import dayjs from "dayjs";

  // Initialize from sessionStorage so filters reset when tab/window closes
  const storedEmployeeRaw = sessionStorage.getItem("et_selected_employee");
  const storedEmployee = storedEmployeeRaw ? Number(storedEmployeeRaw) : "";
  const storedDate = sessionStorage.getItem("et_selected_date");
  const storedPersonType = sessionStorage.getItem("et_selected_person_type") || "1";

  const initialDate = storedDate ? dayjs(storedDate) : dayjs();

  const useEmployeeTaskViewerFilterStore = create((set) => ({
    selectedPersonType: storedPersonType,
    selectedEmployee: storedEmployee,
    selectedDate: initialDate,
    apiDate: initialDate,
    pagination: {
      page: 0,
      pageSize: 20,
      total: 0,
    },

    setSelectedPersonType: (value) => {
      sessionStorage.setItem("et_selected_person_type", value);
      set({ selectedPersonType: value });
    },

    setSelectedEmployee: (value) => {
      sessionStorage.setItem("et_selected_employee", value);
      set({ selectedEmployee: value });
    },

    setSelectedDate: (value) => {
      if (!value) {
        sessionStorage.removeItem("et_selected_date");
        set({ selectedDate: null });
        return;
      }
      sessionStorage.setItem("et_selected_date", value.toISOString());
      set({ selectedDate: value });
    },

    setApiDate: (value) => {
      if (!value) {
        sessionStorage.removeItem("et_selected_date");
        set({ apiDate: null });
        return;
      }
      set({ apiDate: value });
    },

    setPagination: (updater) =>
      set((state) => {
        const current = state.pagination;
        if (typeof updater === "function") {
          return { pagination: updater(current) };
        }
        return { pagination: { ...current, ...updater } };
      }),

    resetFilters: () => {
      sessionStorage.removeItem("et_selected_employee");
      sessionStorage.removeItem("et_selected_date");
      sessionStorage.removeItem("et_selected_person_type");
      set({
        selectedPersonType: "1",
        selectedEmployee: "",
        selectedDate: dayjs(),
        apiDate: dayjs(),
        pagination: {
          page: 0,
          pageSize: 20,
          total: 0,
        },
      });
    },
  }));

  export default useEmployeeTaskViewerFilterStore;